// service-worker.js কে রেজিস্টার করার হেল্পার — এর ফলে ফোনে
// "Add to Home Screen" করলে অ্যাপটা আইকন হয়ে বসবে এবং দ্রুত/অফলাইন-ফ্রেন্ডলি হবে।
// শুধু production build-এ কাজ করে (npm run build), development (npm start)-এ না।

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.\d{1,3}){3}$/)
);

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    if (isLocalhost) {
      verifyServiceWorker(swUrl);
    } else {
      registerServiceWorker(swUrl);
    }
  });
}

function registerServiceWorker(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;
        installing.onstatechange = () => {
          if (installing.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // পুরনো ভার্সন এখনো চলছে, নতুন ভার্সন পরের বার অ্যাপ খুললে অ্যাকটিভ হবে
              console.log('নতুন আপডেট রেডি — পরেরবার অ্যাপ খুললে দেখা যাবে।');
            } else {
              console.log('অ্যাপ এখন অফলাইনেও ব্যবহার করা যাবে।');
            }
          }
        };
      };
    })
    .catch((err) => console.error('Service worker registration failed:', err));
}

function verifyServiceWorker(swUrl) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || (contentType && contentType.indexOf('javascript') === -1)) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerServiceWorker(swUrl);
      }
    })
    .catch(() => console.log('ইন্টারনেট কানেকশন নেই — অফলাইন মোডে চলছে।'));
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready.then((registration) => {
    registration.unregister();
  });
}
